<template>
  <div class="" v-if="algolia !== null">
    <ListContent
      :algolia="algolia"
    >
      <template v-slot:filters>
        <ShipmentsFilters />
      </template>
      <template v-slot:listActionPanel>
        <ListActionPanel
        :isCheckable="true"
        >
          <template v-slot:extraButtons>
            <ExportShipmentList @changeDialog="dialog = true" />
            <v-tooltip
            v-if="computedShipmentsInSameDay"
            bottom>
              <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                @click="handleOpenPlanner(computedShipmentsInSameDay)"
              >
                <v-icon size="18" color="#767676">{{'fas fa-chalkboard-teacher'}}</v-icon>
              </v-btn>
              </template>
              <span>{{ $t('shipments.shipments_maximum_number') }}</span>
            </v-tooltip>
          </template>
        </ListActionPanel>
      </template>
      <template v-slot:list>
        <ais-hits>
          <div
          v-if="items.length > 0"
          slot-scope="{ page, items}"
          >
            <ListItemCardBig
              v-for="item in items"
              :key="item.objectID"
              :color="getShipmentCardColor(item.type)"
              :resource="{...item, id: item.objectID}"
              @cardClicked="handleShipmentSelect"
            >
              <Card1PL :shipment="item"/>
            </ListItemCardBig>
          </div>
          <div v-else>
            {{ $t('shipments.empty_shipments') }}
          </div>
        </ais-hits>
      </template>
    </ListContent>
    <!-- <v-dialog v-model="dialog" width="250">
      <v-card>
        <v-card-title class="subheading text-center">
          {{$t('print_files.no_shipments_to_print')}}
        </v-card-title>
        <v-card-actions class="justify-center">
          <v-btn @click="dialog = false" color="#EF476F" class="white--text">{{$t('print_files.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Auth } from '@/_services/amplify.service.js'
import { algoliaService } from '@/_services'
import moment from 'moment-timezone'
import { uuid } from 'vue-uuid'
import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import ListContent from '@/components/wrld/generic/ListContent'
import ListActionPanel from '@/components/wrld/generic/ListActionPanel'
import Card1PL from '@/components/shipments/new/cards/Card1PL'
import ShipmentsFilters from '@/components/shipments/new/ShipmentsFilters'
import ExportShipmentList from '@/components/shipments/new//ExportShipmentList'

export default {
  name: 'ShipmentsOverviewContent',
  components: {
    ListItemCardBig,
    ListContent,
    ListActionPanel,
    Card1PL,
    ShipmentsFilters,
    ExportShipmentList
  },
  props: {},
  data () {
    return {
      algolia: null,
      dialog: false,
      shipmentsDays: []
    }
  },
  created () {
    Auth.currentSession().then((session) => {
      this.algolia = { indexName: 'prod_shipments_v2',
        urlSync: true,
        searchParameters: {
          filters: `viewableBy:${session.getIdToken().payload.org}`
        } }
    })
  },
  computed: {
    ...mapGetters([
      'getCheckedOnPageCount',
      'getActualListPage',
      'getSelectedResourceID',
      'getCheckedOnPage',
      'getLoggedInUserOrganization',
      'getResourceOverviewList'
    ]),
    actualPage () {
      return this.getActualListPage
    },
    checkedOnPageCount () {
      return this.getCheckedOnPageCount(this.actualPage)
    },
    computedShipmentsInSameDay () {
      const checkedShipments = this.getCheckedOnPage(this.actualPage)
      if (checkedShipments != null) {
        const departures = Object.values(checkedShipments).map(({ pickupLocal, pickupUTC }) => {
          // TODO pickupLocal is in UTC
          // return moment.unix(pickupLocal.from).tz('Europe/Prague').set({
          //   hour: 0,
          //   minute: 0,
          //   second: 0,
          //   millisecond: 0
          // }).unix()
           return moment.unix(pickupUTC.from).tz('UTC').set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          }).unix()
        })
        // Check if all checked shipments have the same departure
        const isSameDay = departures.every((val, i, arr) => val === arr[0])
        if (isSameDay) {
          if (departures.length < 1) {
            return false
          }
          return { shipmentIDs: Object.values(checkedShipments).map(({ id }) => id), day: departures[0] }
        } else if (departures.length > 0) {
          this.showSnackbar({ message: this.$i18n.t('shipments.shipments_opened_planner'), color: 'warning' })
          return false
        }
      }
      return false
    }
    // cardActions () {
    //   let icons = []
    //   if (this.checkedOnPageCount > 0) {
    //     icons.push(
    //       this.exportIcon
    //     )
    //   }
    //   return icons
    // }
  },
  methods: {
    ...mapActions({
      updateResource: 'updateResource',
      selectUnit: 'selectUnit',
      setShipmentDetails: 'setShipmentDetails',
      removeShipment: 'removeShipment',
      removeShipmentDetails: 'removeShipmentDetails',
      showSnackbar: 'showSnackbar',
      newPlannerDoc: 'newPlannerDoc'
    }),
    handleShipmentSelect (shipmentID) {
      this.selectUnit({ unit: null })
      if (this.getSelectedResourceID.objectID !== null) {
        this.removeShipmentDetails()
        this.setShipmentDetails({ shipmentID: this.getSelectedResourceID.objectID })
      }
    },
    handleOpenPlanner ({ day, shipmentIDs }) {
      // algoliaService.getShipmentsForSpecificDay({ day }).then((shipments) => {
      //   this.newPlannerDoc({ docDay: day, shipments })
      //   this.$router.push({ path: 'planner', query: { day: moment.unix(day).format('YYYY-MM-D') } })
      // })
      if (shipmentIDs.length < 6) {
        this.$router.push({ path: 'planner', query: { day, shipmentIDs } })
      } else {
        // TODO i18n message
        this.showSnackbar({ message: 'The Maximum number of concurrently open shipments in planner is 5', color: 'warning' })
      }
    },
    getShipmentCardColor (type) {
      let color = ''
      if (type === '1PL') {
        color = '#50E898'
      } else {
        color = '#50E898'
      }
      return color
    },
    getShipmentsDays (event) {
      algoliaService.getShipmentsDepartureDays({ hits: 5 }).then((response) => {
        this.shipmentsDays = response.map(({ value }) => {
          return { id: uuid.v1(), departure: value, text: moment.unix(value).format('ddd, MMM DD YYYY') }
        })
        this.shipmentsDays.push({
          id: 'show_more',
          value: 'show_more',
          text: 'Show more'
        })
      })
    },
    handleShowMorePlannerDays () {
      const showMoreHits = this.shipmentsDays.length + 5
      algoliaService.getShipmentsDepartureDays({ hits: showMoreHits }).then((response) => {
        this.shipmentsDays = response.map(({ value }) => {
          return { id: uuid.v1(), departure: value, text: moment.unix(value).format('ddd, MMM DD YYYY') }
        })
        this.shipmentsDays.push({
          id: 'show_more',
          value: 'show_more',
          text: 'Show more'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
